export const CHART_LICENSE = "CH262668106";
